import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchPurchaseOrderArrivalScheduleDetail(
  poId,
  scheduleId,
) {
  const { data: raw } = await request.get(
    `/srm/purchase-order/${poId}/arrival-schedules/${scheduleId}`,
  );
  return parseVer4DetailResponse(raw);
}
